export default {
  divisionStockItems: [],
  favouriteStockItems: [],
  stockItems: [],
  stockItem: undefined,
  stockLimits: [],
};
